import { Image, Media } from '@tribeplatform/gql-client/types'

export const Logo = ({
  image,
  alt,
  size = 'sm',
}: {
  image: Media
  alt: string
  size?: 'sm' | '3xl' | '3xl-square'
}) => {
  let height
  let width
  image = image as Image

  if (!image?.urls?.small) {
    height = 32
    width = 265
  }

  if (image?.width && image.height) {
    height = 32
    width = Math.round((image.width * 32) / image.height)
  }

  if (size === '3xl') {
    return (
      <img
        className="bg-surface-50 inline-block object-contain h-32 w-96"
        height={128}
        width={128 * 3}
        src={image?.urls?.small || '/images/placeholder-logo.png'}
        alt={alt}
      />
    )
  }

  if (size === '3xl-square') {
    return (
      <img
        className="bg-surface-50 inline-block object-contain h-32 w-32"
        height={128}
        width={128}
        src={image?.urls?.small || '/images/placeholder-logo.png'}
        alt={alt}
      />
    )
  }

  return (
    <div style={{ maxWidth: '300px' }} className="max-h-8 block">
      <img
        className="object-contain h-8 max-h-full max-w-full"
        width={width}
        height={height}
        src={image?.urls?.small || '/images/placeholder-logo.png'}
        alt={alt}
      />
    </div>
  )
}
